import React from 'react';

export const CheckCircleIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" fill="#2C5695"/>
        <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
